import React, { useState, useEffect } from "react";
import {
  Container,
  Typography,
  IconButton,
} from "@mui/material";
import { Add } from "@mui/icons-material"; // Import the Add icon
import { collection, query, where, onSnapshot } from "firebase/firestore";
import { firestore as db } from "../components/firebase.config"
import ChecklistForm from "./ChecklistForm"; // Import ChecklistForm component
import AdminChecklistView from "./AdminChecklistView"; // Import AdminChecklistView component

const AdminChecklist = ({ email }) => {
  const [tasks, setTasks] = useState([]);
  const [openForm, setOpenForm] = useState(false); // State to control form visibility
  const [selectedChecklist, setSelectedChecklist] = useState(null); // To manage selected checklist for editing

  useEffect(() => {
    if (!email) {
      console.error("No email passed to AdminChecklist.");
      return;
    }

    console.log("Passed Email:", email); // Debugging: Log the passed email

    // Fetching checklists created by the specific admin
    const adminChecklistsQuery = query(
      collection(db, "checklists"),
      where("createdBy", "==", email)
    );

    const unsubscribe = onSnapshot(adminChecklistsQuery, (snapshot) => {
      const fetchedTasks = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setTasks(fetchedTasks);
    });

    return () => unsubscribe();
  }, [email]);


  const handleCloseForm = () => {
    setOpenForm(false); // Close the form
    setSelectedChecklist(null); // Clear any previously selected checklist for editing
  };

  return (
    <Container>
      <Typography variant="h4" sx={{ my: 2 }}>
        Admin Checklist
      </Typography>


      {/* Display the ChecklistForm when openForm is true */}
      {openForm && (
        <ChecklistForm
          email={email} // Pass the email prop
          onClose={handleCloseForm}
          selectedChecklist={selectedChecklist}
        />
      )}

      {/* Admin Checklist View */}
      <AdminChecklistView tasks={tasks} />
    </Container>
  );
};

export default AdminChecklist;
